import { JSX, ReactNode } from 'react'

export interface NonVisiblePage {
  name: string
  title: string
  subtitle?: ReactNode | string
  path: string
  element: ReactNode
}

export interface Page {
  name: string
  title: string
  subtitle?: ReactNode | string
  path: string
  icon: JSX.Element
  element: ReactNode
}

export function isVisiblePage(page: Page | NonVisiblePage): page is Page {
  return (page as Page).icon !== undefined
}
